import React from "react";
import { Div, Text, Image } from "atomize";
import CustomContainer from "../common/CustomContainer";
import WebsiteContainer from "../common/WebsiteContainer";

import ImageLink from "../common/ImageLink";
import RichTextEditor from "../common/RichTextEditor";

const CaseStudy = ({ caseStudy }) => (
  <WebsiteContainer>
    <CustomContainer>
      <Div m={{ xs: "0 -1.5rem", md: "0" }}>
        <Div
          p={{
            t: "3.5rem",
            b: "5.25rem",
          }}
          bg={caseStudy.color || "blueGray"}
          textColor="white"
        >
          <Div maxW="52rem" m="0 auto" className="blog-page">
            <Div p={{ xs: "0 1.5rem", sm: "0 2.5rem", xl: "0" }}>
              <Div d="flex" flexDir="column" align="center">
                <ImageLink link={caseStudy.userImage.description}>
                  <Image
                    src={caseStudy.userImage.file.url}
                    w="3.6rem"
                    h="3.6rem"
                    m={{
                      t: { xs: "1rem", md: "0.5rem" },
                      b: "0.75rem",
                    }}
                    rounded="circle"
                  />
                </ImageLink>
                <Text p={{ x: "0.5rem" }} textSize="body" textWeight="700">
                  {caseStudy.userName}
                </Text>
                <Text
                  p={{
                    b: { xs: "3.1rem", md: "4.25rem" },
                    x: "0.5rem",
                  }}
                  textSize="caption2"
                >
                  {caseStudy.companyName}
                </Text>
                <Text
                  style={{ letterSpacing: "2.5px" }}
                  textWeight="600"
                  textSize="caption1"
                >
                  CASE STUDY
                </Text>
                <Text
                  textAlign="center"
                  m={{ t: "1rem" }}
                  textSize="heading1"
                  textWeight="600"
                  tag="h1"
                >
                  “{caseStudy.title}”
                </Text>
                <ImageLink link={caseStudy.companyLogo.description}>
                  <Image
                    src={caseStudy.companyLogo.file.url}
                    maxW="8.5rem"
                    p={{
                      t: { xs: "1.1rem", md: "2rem" },
                      b: "2.5rem",
                    }}
                  />
                </ImageLink>
              </Div>
              <Div className="blog-content">
                <RichTextEditor json={caseStudy.content.json} />
              </Div>
            </Div>
          </Div>
        </Div>
      </Div>
    </CustomContainer>
  </WebsiteContainer>
);

export default CaseStudy;
